export default __webpack_public_path__ + "img/pin_icons/heater_b.png";